import toast from 'react-hot-toast';
import { useQuery } from 'react-query';

import {
  TITVPastEventsResponse,
  TITV_PAST_EVENTS_KEY,
  fetchTITVPastEvents,
  fetchTITVPastEventsByNetwork,
} from '@utils/backend-api/titv';

interface UseTITVPastEventsProps {
  networkId?: number;
  page?: number;
  pageSize?: number;
}

export default function useTITVPastEvents({
  networkId,
  page = 1,
  pageSize = 6,
}: UseTITVPastEventsProps) {
  const { data, isLoading } = useQuery<TITVPastEventsResponse>(
    [TITV_PAST_EVENTS_KEY, networkId, page, pageSize],
    () =>
      networkId
        ? fetchTITVPastEventsByNetwork({ network_id: networkId, page, page_size: pageSize })
        : fetchTITVPastEvents({ page, page_size: pageSize }),
    {
      onError: () => {
        console.error('Failed to load past events');
        toast.error("We couldn't load past events. Please try again later.");
      },
      keepPreviousData: true,
      retry: 1,
    }
  );

  return {
    currentPage: data?.currentPage ?? 1,
    events: data?.events ?? [],
    isLoading,
    totalPages: data?.totalPages ?? 1,
  };
}
